import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { ServiceBlock } from '../../components/service_block/service_block';
import { IService } from '../../models/service';
import { IMainPage } from '../../models/mainpage';
import { IRegionsData } from '../../models/regions_data';
import { IPromo } from '../../models/promo';
import { resendSMS, sendSMS } from '../../redux/modules/services';

import { trackService, trackPremium } from '../../helpers/metrics_helper';

interface IProps {
  dispatch?: Dispatch<any>;
  service: IService;
  regionsData: IRegionsData;
  promo: IPromo[];
  section: string;
}

class ServicesComponent extends React.Component<IProps> {

  public constructor(props: IProps) {
    super(props);
    this.onSendSMS = this.onSendSMS.bind(this);
    this.onResendSMS = this.onResendSMS.bind(this);
  }

  public render() {
    if (this.props.promo.length > 0) {
      return (
        <ServiceBlock
          onAdsClick={(eventLabel: string) => trackService(eventLabel)}
          onPremClick={(eventLabel: string) => trackPremium(eventLabel)}
          coordinates={this.props.regionsData.subdomainRegionCoordinates}
          service={this.props.service}
          section={this.props.section}
          onSendSMS={this.onSendSMS}
          onResendSMS={this.onResendSMS}
        />
      );
    } else {
      return (<div/>);
    }
  }

  private onSendSMS(phone: string) {
    if (this.props.dispatch) {
      this.props.dispatch(sendSMS(phone));
    }
  }

  private onResendSMS() {
    if (this.props.dispatch) {
      this.props.dispatch(resendSMS());
    }
  }
}

export const Services = connect<IProps, {}, {}>((state: {
  service: IService,
  mainpage: IMainPage,
}) => ({
  service: state.service,
  regionsData: state.mainpage.regionsData,
  promo: state.mainpage.promoBlocks,
  section: state.mainpage.section,
}))(ServicesComponent);
